<form [formGroup]="formData" novalidate>
  <div class="modal-header">
    <h4 class="modal-title">
      Add SKU Items
      <small *ngIf="isSampleOrder">[Sample Order]</small>
      <small *ngIf="!isSampleOrder">[Bulk Order]</small>
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" *ngIf="settingsSvc.masterfile$ | async as settings">
    <div class="row">
      <div class="col-md-6">
        <h5 *ngIf="settings && settings.LOGISTICS">
          <small>Incoterm: </small>
          {{ settings.LOGISTICS[formValue.logistic] }}
        </h5>
      </div>
      <div class="col-md-6">
        <h5 class="m-0 p-0">
          <b>{{ poService.itemCount }}</b> <small> items added </small>
        </h5>
      </div>
    </div>
    <hr />
    <div class="form-group" *ngIf="factoryItems && factoryItems.length > 0">
      <label for="">Search Item</label>
      <ng-select
        [items]="factoryItems"
        bindLabel="label"
        bindValue="id"
        formControlName="rfq_id"
        [multiple]="false"
        (change)="showQuotations()"
      >
        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
          <div class="ng-option disabled">
            <button
              class="btn btn-default"
              type="button"
              (click)="addLineItem(searchTerm)"
              >Add line item</button
            >
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div
      class="row"
      *ngIf="!customItem && activeRfq && settings && settings.LOGISTICS"
    >
      <div class="col-md-4">
        <h4>Tiered Pricing</h4>
        <ul>
          <li *ngFor="let vq of variantQuotes">
            <a
              href="javascript:;"
              (click)="setActiveVariantQuote(vq)"
              class="text-capitalize"
            >
              {{ vq.label }}
            </a>
          </li>
        </ul>
      </div>
      <div class="col-md-8">
        <h5 class="text-capitalize">{{ activeVariantQuote.label }}</h5>
        <table class="table table-bordered" *ngIf="quotation && !isSampleOrder">
          <thead>
            <tr>
              <th> Units </th>
              <th>
                {{ settings.LOGISTICS[quotation.logistic_1] | translate }}
              </th>
              <th *ngIf="quotation.logistic_2">
                {{ settings.LOGISTICS[quotation.logistic_2] | translate }}
              </th>
            </tr>
          </thead>
          <tbody
            *ngFor="let tp of activeVariantQuote.tiered_pricing_json; let i = index"
          >
            <tr
              *ngIf="tp?.quantity > 0 && (tp?.logistic_1 > 0 || tp?.logistic_2 > 0)"
            >
              <ng-template #logistic1>
                <div class="text-center">
                  <span
                    *ngIf="
                      !tp.logistic_1_downpayment_percent ||
                      tp.logistic_1_downpayment_percent == 100
                    "
                  >
                    100 % Down
                  </span>
                  <span
                    *ngIf="
                      tp.logistic_1_downpayment_percent &&
                      tp.logistic_1_downpayment_percent < 100
                    "
                  >
                    {{
                      tp.logistic_1_downpayment_percent +
                        ' / ' +
                        tp.logistic_1_finalpayment_percent
                    }}
                  </span>
                </div>
              </ng-template>
              <ng-template #logistic2>
                <div class="text-center">
                  <span
                    *ngIf="
                      !tp.logistic_2_downpayment_percent ||
                      tp.logistic_2_downpayment_percent == 100
                    "
                  >
                    100 % Down
                  </span>
                  <span
                    *ngIf="
                      tp.logistic_2_downpayment_percent &&
                      tp.logistic_2_downpayment_percent < 100
                    "
                  >
                    {{
                      tp.logistic_2_downpayment_percent +
                        ' / ' +
                        tp.logistic_2_finalpayment_percent
                    }}
                  </span>
                </div>
              </ng-template>
              <ng-template #popTitle>
                <span>Payment Terms</span>
              </ng-template>

              <td>{{ tp.quantity }} </td>
              <td
                *ngIf="quotation.logistic_1"
                [ngbPopover]="logistic1"
                [popoverTitle]="popTitle"
                placement="top"
                triggers="mouseenter:mouseleave"
                container="body"
              >
                <span>{{ tp.logistic_1 | currency: '' : 'symbol' : '1.2-4' }}</span>
                <!-- <strong>
                                    {{ (tp.logistic_1 + (tp.logistic_1 * tp.logistic_1_markup_percent / 100)) | currency: "":"symbol":'1.2-4' }}
                                </strong> -->
              </td>
              <td
                *ngIf="quotation.logistic_2"
                [ngbPopover]="logistic2"
                [popoverTitle]="popTitle"
                placement="top"
                triggers="mouseenter:mouseleave"
                container="body"
              >
                <span>{{ tp.logistic_2 | currency: '' : 'symbol' : '1.2-4' }}</span>
                <!-- <strong>
                                    {{ (tp.logistic_2 + (tp.logistic_2 * tp.logistic_2_markup_percent / 100)) | currency: "":"symbol":'1.2-4' }}
                                </strong> -->
              </td>
            </tr>
          </tbody>
        </table>
        <div class="sample-prices" *ngIf="activeVariantQuote.sample_price > 0">
          <div>
            <span>Sample Price: </span>
            <b>{{ activeVariantQuote.sample_price | currency: '' }}</b>
          </div>
          <div>
            <span>Sample Lead Time: </span>
            <b>{{ activeVariantQuote.sample_lead_time_days }} Days</b>
          </div>
        </div>
      </div>
    </div>

    <fieldset *ngIf="variantExists">
      <legend>Variants</legend>
      <div class="row" formGroupName="variants">
        <div class="col-md-12 variant-selections">
          <div
            class="form-group form-inline"
            *ngFor="let variant of activeRfq.product_variants; let i = index"
          >
            <label for="">{{ variant.variant_name }}: </label>
            <select
              class="form-control"
              [formControlName]="variant.variant_name"
              (change)="computeTotal()"
            >
              <!-- <option value="">&nbsp;</option> -->
              <option [value]="term" *ngFor="let term of variant.variant_terms">{{
                term
              }}</option>
            </select>
          </div>
        </div>
      </div>
    </fieldset>

    <div class="clearfix"></div>

    <div *ngIf="activeRfq">
      <div class="row" *ngIf="customItem">
        <div class="col-md-6">
          <label for="">Custom item: </label>
          <span class="form-control">
            {{ activeRfq.product_name }}
          </span>
        </div>
        <div class="col-md-6">
          <label for="">Unit Price: </label>
          <input
            type="number"
            *ngIf="activeRfq.id < 0"
            class="form-control"
            formControlName="unit_price"
            (change)="computeTotal()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="">Source SKU: </label>
            <input type="text" class="form-control" formControlName="source_sku" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="">Order Quantity: </label>
            <input
              type="number"
              class="form-control"
              formControlName="quantity"
              (change)="computeTotal()"
              (keydown.enter)="tryAddItem()"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="">Unit Price: </label>
            <span class="total" *ngIf="activeRfq.id >= 0">
              {{ unitPrice | currency: '' }}
            </span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="">Total First: </label>
            <span class="total">
              {{ totalFirst | currency: '' }}
            </span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="">Total Order Cost: </label>
            <span class="total">
              {{ totalCost | currency: '' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      id="kt_submit"
      class="btn btn-brand"
      [disabled]="!totalCost || totalCost <= 0"
      (click)="tryAddItem()"
    >
      <i class="fas fa-plus"></i> Add Item
    </button>

    <!-- <button type="button" class="btn btn-success" (click)="activeModal.dismiss()">
            <i class="fas fa-check"></i> Done
        </button> -->
  </div>
</form>
